import React, { Component, Fragment } from 'react';
import { message, Pagination } from 'antd';
import 'video-react/dist/video-react.css';
import videoApi from '../../api/videoApi';
import Video from './video';
import LiveVideo from './liveVideo';

export class VideoComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 6,
      total: '',
      videoData: [],
    };
  }

  componentDidMount() {
    this.getVideoList();
  }

  getVideoList = () => {
    const data = {
      page: this.state.page,
      limit: this.state.limit,
      catalog: this.props.catalogId,
    };

    videoApi.videoList(data).then((res) => {
      if (res.status === 200) {
        const data = res.data.data.data;
        this.setState({
          videoData: data,
          total: res.data.data.total,
        });
      } else {
        let error_msgs = '',
          msgs = res.data.msg;
        if (typeof msgs == 'object') {
          Object.keys(msgs).forEach((key) => {
            return (error_msgs += `${msgs[key]};`);
          });
        } else {
          error_msgs = msgs;
        }
        message.error(error_msgs);
      }
    });
  };

  /** 当前页码 */
  onChangeCurrnePage = (page, pageSize) => {
    if (page < 1) {
      page = this.state.page;
    }
    const data = {
      page: page,
      limit: pageSize,
      catalog: this.props.catalogId,
    };

    videoApi.videoList(data).then((res) => {
      if (res.status === 200) {
        const data = res.data.data.data;
        this.setState({
          videoData: data,
        });
      }
    });
  };

  render() {
    const { videoData, page, limit, total } = this.state;
    const { catalogId } = this.props;

    return (
      <Fragment>
        {catalogId === 5 ? (
          <LiveVideo
            videoData={videoData}
            page={page}
            limit={limit}
            total={total}
          />
        ) : null}
        {catalogId === 4 ? (
          <Video
            videoData={videoData}
            page={page}
            limit={limit}
            total={total}
          />
        ) : null}

        <div style={{ paddingBottom: 30 }}>
          <Pagination
            total={total}
            onChange={this.onChangeCurrnePage}
            pageSize={this.state.limit}
            hideOnSinglePage
          />
        </div>
      </Fragment>
    );
  }
}

export default VideoComponent;
